<template>
  <div>
    <table class="table profile-table table-responsive-lg overflow-y-xs">
      <tr>
        <th>{{ $t( 'cert' ) }}</th>
        <th>{{ $t( 'form.lastname' ) }}</th>
        <th>{{ $t( 'qualif' ) }}</th>
        <th>{{ $t( 'validity' ) }}</th>
        <th>{{ $t( 'dlv' ) }}</th>
        <th>{{ $t( 'ext' ) }}</th>
        <th>{{ $t( 'iata' ) }}</th>
      </tr>
      <tbody class="box-block">
      <habilitation-row
          v-for="(habilitation, index) in habilitationsList"
          :key="habilitation.id"
          :index="index"
          :habilitation="habilitation"
          :user="user"
      ></habilitation-row>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import HabilitationRow from './HabilitationRow.vue';

export default {
  name: 'HabilitationTable',
  props: {
    habilitationsList: {
      required: true,
      default: [],
      type: Array
    }
  },
  components: {
    HabilitationRow
  },
  computed: {
    ...mapFields( [ 'user' ] )
  }
};
</script>

<style></style>
